export default {"src":"/_next/static/media/searchWhite.4a9e7488.svg","height":30,"width":30};